enum DLXDriveAccessGroupType {
  AccessGroup = 0,
  Department = 1,
  User = 2,
}

export default DLXDriveAccessGroupType;
